import { load } from 'worker-timers-broker';
import { createLoadOrReturnBroker } from './factories/load-or-return-broker';
import { worker } from './worker/worker';
const loadOrReturnBroker = createLoadOrReturnBroker(load, worker);
export const clearInterval = (timerId) => loadOrReturnBroker().clearInterval(timerId);
export const clearTimeout = (timerId) => loadOrReturnBroker().clearTimeout(timerId);
export const setInterval = (func, delay) => loadOrReturnBroker().setInterval(func, delay);
export const setTimeout = (func, delay) => loadOrReturnBroker().setTimeout(func, delay);
//# sourceMappingURL=module.js.map